import * as Api from '../api';
import { get as _get } from './get';
import { pipe } from 'fp-ts/lib/function';
import * as Url from '../api/url';
const buildGetUrl = (config, spaceId, selections, count) => Url.toString({
    base: config.compatibility,
    path: `/api/v1/${config.tenant}/configurations`,
    query: {
        space: spaceId,
        selections: Api.Configuration.Selections.toString(selections),
        ...(count && { count: count.toString() }),
    },
});
export const getConfiguration = (config, spaceId, selections) => {
    return pipe(buildGetUrl(config, spaceId, selections), _get);
};
// TODO, get all configurations from paginated response
export const getConfigurations = (config, spaceId, selections, count = 20) => {
    return pipe(buildGetUrl(config, spaceId, selections, count), _get);
};
